module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      framePicker: true, active: _vm.active, relative: true
    }
  }, [(!_vm.loading && _vm.frames && _vm.steps.pictureWall) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      articleContainer: true, several: _vm.several
    }
  }, [_c('div', {
    staticClass: "centerSlider",
    attrs: {
      "id": "frameArticleSlider"
    }
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-field": "all"
    }
  }, [_c('div', {
    staticClass: "productShell"
  }, [_c('img', {
    attrs: {
      "src": _vm.wgURL + '/general/dummy-article.jpg'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t('allArticles')) + " ")])])]), _vm._v(" "), _vm._l((_vm.articles), function(article, index) {
    return (_vm.getFrameField(index)) ? _c('div', {
      key: index,
      staticClass: "item",
      attrs: {
        "data-field": index
      }
    }, [(!_vm.chosenArticles[_vm.getArticleFieldID(article.item)]) ? _c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "productShell"
    }, [_c('img', {
      attrs: {
        "src": _vm.wgURL + '/general/dummy-article.jpg'
      }
    })])]) : _c('div', {
      staticClass: "chosenArticle"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('img', {
      attrs: {
        "src": _vm.getArticleImage(_vm.chosenArticles[index + 1])
      }
    })])])]) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.active) ? _c('div', {
    staticClass: "framesContainer",
    attrs: {
      "id": "bottomFrameContainer"
    }
  }, [_c('div', {
    staticClass: "listing",
    attrs: {
      "id": "frameSlider"
    }
  }, [_c('div', {
    staticClass: "frameItem item third deleteFrameItem show-for-mobile-inline activePop",
    on: {
      "click": function($event) {
        _vm.deleteFrames(_vm.frame)
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _vm._l((_vm.frames['list']), function(frame, name) {
    return _c('div', {
      key: frame.id,
      staticClass: "frameItem item third smooth activePop",
      on: {
        "click": function($event) {
          _vm.pickFrame(name, frame)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getArticleImageDB(frame)
      }
    })])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hide-for-mobile",
    attrs: {
      "id": "removeFramesContainer"
    },
    on: {
      "click": _vm.deleteFrames
    }
  }, [_c('div', {
    staticClass: "button",
    attrs: {
      "id": "removeFrames"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" " + _vm._s(_vm.$t('removeFrame')) + "\n\t\t\t\t")])])]) : _vm._e(), _vm._v(" "), (!_vm.steps.pictureWall) ? _c('div', {
    staticClass: "noPictureWall"
  }, [_vm._v("\n\t\t\t " + _vm._s(_vm.$t('choosePictureWallBeforeFrames')) + "\n\t\t")]) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "fade-in": "fadeIn",
      "fade-out": "fadeOut",
      "classes": "cover dimmer",
      "identifier": "framesPicker"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deleteFrameItemPic"
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a3eb537e!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Picker/FramePicker.vue
// module id = 169
// module chunks = 0